import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { OnboardingPages } from '../../../../common/src/pages.ts';
import { Button } from './button.tsx';
import { goToNextOnboardingStep, isAdminInvite, isHouseholdInvite, Message } from './common.tsx';
import { Frame } from './frame.tsx';

export const HouseholdStart = () => {
  const navigate = useNavigate();
  const onContinue = useCallback(async () => {
    await goToNextOnboardingStep(navigate, { from: OnboardingPages.HouseholdStart, action: 'continue' });
  }, [navigate]);
  return (
    <Frame
      onboardingPage={OnboardingPages.HouseholdStart}
      mainContent={
        <MessageWrapper>
          <Message $widthInChars={22}>
            {isAdminInvite()
              ? "Now let's create a household so your family can access the full music library!"
              : "Let's create a household so your family can join!"}
          </Message>
        </MessageWrapper>
      }
      footerContent={<Button onClick={onContinue}>CONTINUE</Button>}
      onEnterKeypress={onContinue}
      suppressBackButton={isAdminInvite() || isHouseholdInvite()}
    />
  );
};

const MessageWrapper = styled.div`
  text-align: center;
`;
